export default __webpack_public_path__ + "static/media/IBMPlexSans-ExtraLightItalic.3f7f1f49.woff";